import { PageHeader, Tag, message, Popconfirm, Tooltip} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { TableItemDinamico, dineroDisabledMask, ButtonItem, SegmentedItem, NotificacionMovimientosInventario } from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { connect } from "react-redux";
import { CloseCircleOutlined, EditOutlined, FileExcelOutlined , InboxOutlined, MailOutlined} from "@ant-design/icons";
import ModalMandarCorreoFacturas from "./ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
import ModalEditarDatosFactura from "../../../Components/ModalEditarDatosFactura";
moment.locale('es')


class FacturasCajaChica extends Component {
  tableRef = null;
  state = {
    todasFacturasCajaChica: [],
    totalRecords: 0,
    valor: 4,
    modalCorreo: false,
    modalCorreoId: null,
    modalEditarDatos: false,
    modalEditarDatosId: null,
  }

  consultarFacturasCajaChica(params = {}) {
    this.setState({ loading: true })
    const body = {
      empresaId: this.props.empresaId,

      ...params,
    };

    axios
      .post(
        "facturascajachica/selectFacturas",
        body,
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        
        let data = [];
        let total = 0;

        if (res.data.success === 2) {
          data = res.data.data;
          total = res.data.totalRecords;
        } else if (Array.isArray(res.data)) {
          // Soporte legacy
          data = res.data;
          total = res.data.length;
        } else if (res.data.status === 404) {
          data = [];
          total = 0;
        }

        this.setState({
          totalRecords: total,
          todasFacturas: data.map((value) => {
            return {
              ...value,
              proveedorNombre: value.proveedorNombre
                ? value.proveedorNombre
                : value.proveedor.nombre
                ? value.proveedor.nombre +
                  " " +
                  value.proveedor.apellidoPaterno +
                  " " +
                  value.proveedor.apellidoMaterno
                : value.proveedor.razonSocial,
              accion: {
                _id: value._id,
                estado: value.estado,
                xml: value.xml,
                estadoPago: value.estadoPago,
                estadoPagoCajaChica: value.estadoPagoCajaChica,
                
              },
            };
          }),
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, todasFacturas: [], totalRecords: 0 });
      });
  }
  agregarFacturaCajaChica() {
    this.props.history.push('/panel/agregarFacturaCajaChica')
  }
  importarGastosXml() {
    this.props.history.push('/panel/importarGastosXmlCajaChica')
  }
  recibirInsumosFactura(id) {
    this.props.history.push('/panel/recibirInsumosFactura', { id, cajaChica: true })
  }
  descargarXml(value) {
    axios
      .post(
        "facturas/descargarXml",
        { facturaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        var xmltext = res.data.string;

        var filename = "file.xml";
        var pom = document.createElement("a");
        var bb = new Blob([xmltext], { type: "text/plain" });

        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);

        pom.dataset.downloadurl = [
          "text/plain",
          pom.download,
          pom.href,
        ].join(":");
        pom.draggable = true;
        pom.classList.add("dragout");

        pom.click();
      });
  }
  cancelarFactura(value) {
    axios
      .post(
        "facturascajachica/cancelarFactura",
        { facturaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Factura cancelada");
          NotificacionMovimientosInventario(res.data.movimientosIds);
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error("Sucedio un error y no se pudo cancelar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  abrirMandarCorreoFactura(id) {
    this.setState({
      modalCorreo: true,
      modalCorreoId: id,
    });
  }

  cerrarMandarCorreoFactura() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
  }

  abrirEditarDatosFactura(id) {
    this.setState({ modalEditarDatos: true, modalEditarDatosId: id });
  }

  cerrarEditarDatosFactura(recargar = false) {
    this.setState({ modalEditarDatos: false, modalEditarDatosId: null });
    if (recargar && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  render() {
    const { todasFacturas, totalRecords, loading } = this.state;
    const columns = [
      {
        title: "Núm",
        dataIndex: "numeroFactura",
        key: "numeroFactura",
       sorter: (a, b) => {
          if (a.codigoFactura < b.codigoFactura) {
            return -1;
          }
          if (a.codigoFactura > b.codigoFactura) {
            return 1;
          }
          return 0;
        },
        buscar: 'numeroFactura',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Codigo",
        dataIndex: "codigoFactura",
        key: "codigoFactura",
        // sorter: (a, b) => {
        //   if (a.codigoFactura < b.codigoFactura) {
        //     return -1;
        //   }
        //   if (a.codigoFactura > b.codigoFactura) {
        //     return 1;
        //   }
        //   return 0;
        // },
        buscar: 'codigoFactura',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        sorter: (a, b) => {
          if (a.proveedorNombre < b.proveedorNombre) {
            return -1;
          }
          if (a.proveedorNombre > b.proveedorNombre) {
            return 1;
          }
          return 0;
        },
        buscar: 'proveedorNombre',
        width: '30%',
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        defaultSortOrder: 'descend',
        sorter: (a, b) => {
          if (moment(a.fechaFactura) < moment(b.fechaFactura)) {
            return -1;
          }
          if (moment(a.fechaFactura) > moment(b.fechaFactura)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('L'),
        width: '9%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: "Recepción",
        dataIndex: "fechaRecepcion",
        key: "fechaRecepcion",
        defaultSortOrder: 'descend',
        render: (value, record) => moment(value || record.createdAt).locale('es').format('L'),
        width: '8%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: 'Subtotal / Total',
        dataIndex: 'subtotal',
        key: 'subtotal',
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>} 
            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.totalPagar)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
          </div>
        ),
        buscar: 'subtotal',
        width: '12%',
        ellipsis: true,
        align: "right",
      },
      {
        title: 'Total',
        dataIndex: 'totalPagar',
        key: 'totalPagar',
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: 'totalPagar',
        responsive: [],
        width: 0,
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        render: (value, record, index) => {
          const tags = [];
          if (value === 0) {
            tags.push(<Tag key={index.toString()} color='red' className="square-tag">Cancelada</Tag>)
          }
          if (value === 1) {
            tags.push(<Tag key={index.toString()} color='blue' className="square-tag">Sin recibir</Tag>)
          }
          if (value === 2) {
            tags.push(<Tag key={index.toString()} color='orange' className="square-tag" style={{ fontSize: 10 }}>Recibido parcialmente</Tag>)
          }
          if (value === 3) {
            tags.push(<Tag key={index.toString()} color='green' className="square-tag">Recibido</Tag>)
          }
          if (record.prorrateoDesCostos) {
            tags.push(<Tag key={`prorrateo-${record._id}`} color='geekblue' className="square-tag">Prorrateo</Tag>)
          }
          return <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>{tags}</div>
        },
        width: '13%',
        ellipsis: true,
      },
      ...(this.props.mostrarComplementoPagoFacturas ? [{
        title: 'Complemento',
        dataIndex: 'tieneComplementoPago',
        key: 'tieneComplementoPago',
        align: 'center',
        width: '8%',
        render: (value) => value
          ? <Tag color="green" className="square-tag3">Con Rep</Tag>
          : <Tag color="gold" className="square-tag3">Sin Rep</Tag>,
      }] : []),
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: "center",
        width: '10%',
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
          if (value.estado === 0) return null

          let buttons = []

          buttons.push(
          <Tooltip title="Mandar correo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            <ButtonItem
              key={`correo-${index}`}
              type="default"
              size="small"
              azul
              icon={<MailOutlined />}
              onClick={() => this.abrirMandarCorreoFactura(value._id)}
            />
          </Tooltip>)

          const puedeDescargarXml = value.estado !== 0 && value.xml;
          if (puedeDescargarXml) {
            buttons.push(
              <Tooltip title="Descargar XML" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`xml-${index}`}
                type="default"
                size="small"
                blanco
                icon={<FileExcelOutlined />}
                onClick={() => this.descargarXml(value._id)}
              >
              </ButtonItem>
              </Tooltip>
            )
          }

          if (this.props.permisoEditarFacturasCajaChica) {
            buttons.push(
              <Tooltip title="Editar datos" key={`editar-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  naranja
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarDatosFactura(value._id)}
                />
              </Tooltip>
            );
          }

          const puedeRecibir = (value.estado === 1 || value.estado === 2) && this.props.permisoAgregarFacturasCajaChica;
          buttons.push(
            <Tooltip title={puedeRecibir ? "Recibir Insumos" : "No disponible"} key={`recibir-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                azul
                type='default'
                size='small'
                onClick={() => puedeRecibir && this.recibirInsumosFactura(value._id)}
                icon={<InboxOutlined />}
                disabled={!puedeRecibir}
              >
              </ButtonItem>
            </Tooltip>
          );

          const puedeCancelar = value.estado !== 0 && value.estadoPagoCajaChica === 0 && this.props.permisoCancelarFacturasCajaChica;
          if (puedeCancelar) {
            buttons.push(
              <Popconfirm
                key={`cancelar-${index}`}
                title="Seguro que quieres cancelar esta factura"
                onConfirm={() => this.cancelarFactura(value._id)}
                okText="Si"
                cancelText="No"
              >
             <Tooltip title="Cancelar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<CloseCircleOutlined />}
                >
                </ButtonItem>
              </Tooltip>
              </Popconfirm>
            )
          }
          // if(value.estado !== 0 && value.estadoPago === 0){
          //   buttons.push(<Popconfirm
          //     title="Seguro que quieres cancelar esta factura"
          //     onConfirm={() => this.cancelarFactura(value._id)}
          //     okText="Si"
          //     cancelText="No"
          //   >
          //     <CloseCircleOutlined style={{ color: "red" }} />
          //   </Popconfirm>)
          // }

          return <div className="acciones-container">{buttons}</div>
        },
      }
    ]
    return (
      <>
        <PageHeader
          title="Facturas Caja Chica"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[
                    { label: 'Sin Recibir', value: 1 },
                    { label: 'Recibido Parcialmente', value: 2 },
                    { label: 'Recibido', value: 3 },
                    { label: 'Cancelada', value: 0 },
                    { label: 'Todos', value: 4 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              }
              {/* Captura rapida: los impuestos salen del XML y solo se elige el gasto */}
              {this.props.permisoAgregarFacturasCajaChica &&
                <ButtonItem
                  key="importarGastosXml"
                  bondi
                  onClick={this.importarGastosXml.bind(this)}
                  style={{ marginRight: 8 }}
                >
                  Importar Gastos XML
                </ButtonItem>}
              {this.props.permisoAgregarFacturasCajaChica &&
                <ButtonItem
                  type="primary"
                  key="agregarFacturaCajaChica"
                  onClick={this.agregarFacturaCajaChica.bind(this)}
                  olivo
                  className="botonAgregar"
                >
                  Agregar Factura
                </ButtonItem>}
            </>
          }
        />
        
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarFacturasCajaChica.bind(this)}
          size="small"
          dataSource={todasFacturas}
          columns={columns}
          pagination={false}
          filterStorageKey={"facturasCajaChicaFiltros" + this.props.empresaId}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} 
          setValor={(valor) => this.setState({ valor })}
          valorDefault={5}
          
          onRow={(record) => {
            return {
              onDoubleClick: () => {
              this.props.history.push('/panel/verFacturaCajaChica', { id: record._id })
              },
            };
          }}
          locale={{ emptyText: "No se encontraron facturas" }}
        />

        <ModalMandarCorreoFacturas
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarModalMandarCorreoFacturas={this.cerrarMandarCorreoFactura.bind(
            this,
          )}
          tipoFactura ="Caja Chica"
        />
        <ModalEditarDatosFactura
          visible={this.state.modalEditarDatos}
          facturaId={this.state.modalEditarDatosId}
          onCancel={() => this.cerrarEditarDatosFactura(false)}
          onSuccess={() => this.cerrarEditarDatosFactura(true)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarFacturasCajaChica: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cc5f7f30e81b54183cf67")?.activado,
    permisoCancelarFacturasCajaChica: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "67508f4b798d4e0043687239")?.activado,
    permisoEditarFacturasCajaChica: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a94a0961aa752bd8701458a")?.activado,
    mostrarComplementoPagoFacturas: state.empresa.mostrarComplementoPagoFacturas,
  };
};

export default connect(mapStateToProps)(FacturasCajaChica);